export default {
  edit: {},
};
